import React, { useCallback } from "react";
import { connect } from "react-redux";

import Select from "antd/es/select";
import { useIntl } from "react-intl";

import {
  schemaFieldTypeFilterOptions,
  SchemaFieldTypeValues,
} from "@mapmycustomers/shared/enum/SchemaFieldType";

import SelectField from "@app/component/input/SelectField";
import { getViewState } from "@app/scene/settings/component/ManageFields/store";
import { updateViewState } from "@app/scene/settings/component/ManageFields/store/actions";
import { RootState } from "@app/store/rootReducer";
import { getSchemaFieldTypeFilterName } from "@app/util/ui";

import styles from "./TypeFilter.module.scss";

interface Props {
  type: SchemaFieldTypeValues;
  updateViewState: typeof updateViewState;
}

const TypeFilter: React.FC<Props> = ({ type, updateViewState }) => {
  const intl = useIntl();

  const handleChange = useCallback(
    (type: SchemaFieldTypeValues) => {
      updateViewState({
        type,
      });
    },
    [updateViewState]
  );

  return (
    <div className={styles.container}>
      <SelectField<SchemaFieldTypeValues>
        className={styles.dropdown}
        dropdownMatchSelectWidth={false}
        onChange={handleChange}
        value={type}
      >
        {schemaFieldTypeFilterOptions.map((value) => (
          <Select.Option key={value} value={value}>
            {getSchemaFieldTypeFilterName(intl, value)}
          </Select.Option>
        ))}
      </SelectField>
    </div>
  );
};

const mapStateToProps = (state: RootState) => ({
  type: getViewState(state).type!,
});

const mapDispatchToProps = {
  updateViewState,
};

export default connect(mapStateToProps, mapDispatchToProps)(TypeFilter);
